import { ErrorType } from './error.types';

export class ValidationError extends Error {
    statusCode = 400;
    code = '';
    data: any;
    type = ErrorType.Validation;
    body: any;

    constructor(message: string, code: string, data?: any, body?: any) {
        super(message);
        this.code = code;
        this.data = data;
        this.body = body;
        Object.setPrototypeOf(this, ValidationError.prototype);
    }
}
